/* Curated, consent-gated storefront interactions for Repubblica's first-party
 * analytics. No form values, arbitrary clicks, contact details or DOM text are
 * collected. Shopify Customer Events is the only transport.
 */
(function () {
  'use strict';
  if (window.RepubblicaAnonymousEvents) return;

  var observedMedia = new WeakSet();
  var viewedMedia = new Set();
  var selectedVariants = new WeakMap();

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed());
    } catch (error) {
      return false;
    }
  }

  function clean(value, maximum) {
    if (typeof value === 'number' && Number.isFinite(value)) return String(Math.trunc(value));
    return typeof value === 'string' ? value.trim().slice(0, maximum || 200) : '';
  }

  function productContext(element) {
    var root = element && element.closest ? element.closest('section-product') : null;
    var script = root && root.querySelector('[data-product-json]');
    if (!script) return { root: root };
    try {
      var product = JSON.parse(script.textContent || '{}').product || {};
      var selected = selectedVariants.get(root) || product.selected_or_first_available_variant || {};
      return {
        root: root,
        product_id: clean(product.id, 32),
        product_handle: clean(product.handle, 160),
        product_title: clean(product.title, 200),
        variant_id: clean(selected.id, 32),
        variant_title: clean(selected.title, 200)
      };
    } catch (error) {
      return { root: root };
    }
  }

  function publish(name, data) {
    if (!analyticsAllowed()) return false;
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') return false;
      var result = analytics.publish(name, window.RPExperience ? window.RPExperience.enrich(data) : (data || {}));
      if (result && typeof result.catch === 'function') result.catch(function () {});
      return true;
    } catch (error) {
      return false;
    }
  }

  window.RepubblicaAnonymousEvents = { publish: publish };

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || variant.id == null) return;
    var context = productContext(event.target);
    if (context.root) selectedVariants.set(context.root, variant);
    publish('repubblica:variant_selected', {
      product_id: context.product_id,
      product_handle: context.product_handle,
      product_title: context.product_title,
      variant_id: clean(variant.id, 32),
      variant_title: clean(variant.title, 200),
      action: 'selected',
      source: 'product_variant_picker'
    });
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = target && target.closest ? target.closest('[data-tg-target^="#PickupAvailabilityModal-"]') : null;
    if (!trigger || !trigger.closest('section-product')) return;
    var context = productContext(trigger);
    publish('repubblica:pickup_viewed', {
      product_id: context.product_id,
      product_handle: context.product_handle,
      product_title: context.product_title,
      variant_id: context.variant_id,
      variant_title: context.variant_title,
      action: 'opened',
      source: 'pdp_pickup_availability'
    });
  }, true);

  var mediaObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
      var media = entry.target;
      var context = productContext(media);
      var mediaId = clean(media.getAttribute('data-media-id'), 32);
      var key = (context.product_id || 'product') + ':' + mediaId;
      if (!mediaId || viewedMedia.has(key)) return;
      viewedMedia.add(key);
      mediaObserver.unobserve(media);
      publish('repubblica:media_viewed', {
        product_id: context.product_id,
        product_handle: context.product_handle,
        product_title: context.product_title,
        variant_id: context.variant_id,
        variant_title: context.variant_title,
        action: clean(media.getAttribute('data-media-type'), 30) || 'media',
        source: 'pdp_gallery'
      });
    });
  }, { threshold: [0.6] }) : null;

  function observeMedia(scope) {
    if (!mediaObserver) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('section-product .MediaModalOpener[data-media-id]').forEach(function (media) {
      if (observedMedia.has(media)) return;
      observedMedia.add(media);
      mediaObserver.observe(media);
    });
  }

  function init() {
    observeMedia(document);
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        Array.prototype.forEach.call(change.addedNodes, function (node) {
          if (node.nodeType === 1) observeMedia(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
